import { Component } from "react";

import axios from "axios";




class Order extends Component {

    constructor() {

        super();

        this.state = {

            pizzaList: [],

        };

    }

    componentDidMount() {

        axios.get("http://localhost:7000/getOrder").then((res) => {

            this.setState({

                pizzaList: res.data,

            });

            console.log(this.state.pizzaList);

        });

    }

    render() {

        var data = this.state.pizzaList.map((pizza) =>

            <div className="containerElement">

                <img src={pizza.image} />

                <div>

                    <h6>{pizza.name}</h6>

                    <h6>{pizza.price}</h6>
                    <h6>{pizza.ingredients[0]}</h6>

                </div>



        </div>
    );

        return (

            <div className="box">

                {data}

            </div>

        );
    

        }

}

export default Order;